{
  "bulkActions": {
    "delete": {
      "action": {
        "name_one": "Supprimer la sélection ({{ count }})",
        "name_many": "Supprimer la sélection ({{ count }})",
        "name_other": "Supprimer la sélection ({{ count }})"
      },
      "modal": {
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "message": "Voulez-vous vraiment supprimer les produits sélectionnés ? Cette action est irrévocable.",
        "title": "Suppression"
      },
      "notifications": {
        "error": {
          "message": "Une erreur est survenue lors de la suppression des produits",
          "title": "Erreur"
        },
        "success": {
          "message": "Produits supprimés avec succès",
          "title": "Produits supprimés"
        }
      }
    },
    "hide_one": "hide",
    "hide_many": "hide",
    "hide_other": "hide",
    "import": {
      "actionName": "Importer"
    },
    "placeholder": "Fiches",
    "show_one": "show",
    "show_many": "show",
    "show_other": "show",
    "title": "Actions"
  },
  "components": {
    "columns": {
      "composition": "Composition",
      "mainFabric": "Tissu principal",
      "reference": "Référence"
    }
  },
  "details": {
    "actions": {
      "delete": "Supprimer"
    },
    "agec": {
      "activity": "{{ activity }} :",
      "microplastics": "Micro-plastiques",
      "na": "Non applicable",
      "primaryPackaging": {
        "primaryPackagingHazardousSubstances": "Substances dangereuses",
        "primaryPackagingRecycled": "Emballage recyclable",
        "primaryPackagingRecycledPercentage": "Matière recyclée (%)",
        "title": "Emballage",
        "withPrimaryPackaging": "Produit vendu dans un emballage primaire"
      },
      "qrCode": {
        "copied": "Copié !",
        "copyLink": "Copier le lien",
        "viewProductSheet": "Fiche produit"
      },
      "recyclability": {
        "title": "Matière recyclée (%)",
        "tooltipByCause": {
          "byEnteredComponentsRecycledPercentage": "Cette valeur est calculée à partir du poids et du pourcentage de matériau recyclé, collectés pour chaque composant du produit.",
          "byIngestedMaterialCompositionRecycledPercentage": "Cette valeur est calculée à partir de la composition déclarée lors de l’ingestion produit. Elle agrège le poids et les proportions des matériaux recyclés de chaque composant du produit.",
          "byIngestedProductRecycledPercentage": "Cette valeur a été fournie par l’organisation dans le fichier d’ingestion du produit. Elle sera mise à jour en fonction des données collectées.",
          "byMixedComponentsRecycledPercentage": "Cette valeur agrège le poids et le pourcentage de matériau recyclé, collectés pour certains composants et les proportions de matériaux recyclés déclarées pour les autres.",
          "notCalculated": "Le poids des composants et leur proportion respective de matériaux recyclés sont indisponibles et ne permettent pas de calculer ce pourcentage."
        }
      },
      "title": {
        "other": "Autres",
        "qrCode": "QR Code",
        "traceability": "Traçabilité"
      }
    },
    "composition": {
      "noComponents": "Aucun composant renseigné"
    },
    "customFields": {
      "fieldInfo": "Informations du champ"
    },
    "delete": {
      "cancel": "Annuler",
      "error": {
        "message": "Une erreur est survenue lors de la suppression du produit",
        "title": "Erreur"
      },
      "message": "Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible et l'ensemble des demandes d'informations et de documents existantes seront annulées.",
      "submit": "Supprimer",
      "success": "Produit supprimé"
    },
    "missing": "{{ activity }} non localisé",
    "properties": {
      "address": "Adresse",
      "collection": "Collection",
      "color": "Couleur",
      "country": "Pays",
      "garment": "Catégorie",
      "item": "Item tracé",
      "marketLaunchDate": "Commercialisation",
      "mass": "Poids",
      "purchaseOrder": "Commande",
      "reference": "Référence",
      "supplier": "Fournisseur"
    },
    "sections": {
      "agec": "Qualités et caractéristiques environnementales",
      "composition": "Composition",
      "customFields": "Données complémentaires",
      "informations": "Informations",
      "suppliers": "Fournisseurs",
      "traceability": "Chaine de traçabilité"
    },
    "suppliers": {
      "noSuppliers": "Aucun fournisseur renseigné.",
      "publicTitle_one": "1 fournisseur localisé.",
      "publicTitle_many": "{{ count }} fournisseurs localisés.",
      "publicTitle_other": "{{ count }} fournisseurs localisés."
    },
    "switch": {
      "hidden": "Données privées",
      "visible": "Données publiques via le moteur de recherche"
    },
    "tabs": {
      "general": "Catalogue"
    }
  },
  "filters": {
    "search": {
      "placeholder": "Rechercher"
    },
    "title": "Filtres"
  },
  "lists": {
    "agecShow": {
      "hidden": "privée",
      "visible": "publique"
    },
    "analysis": {
      "notifications": {
        "error": {
          "message": "Données manquantes pour {{ analysisNumber }} analyses",
          "title": "Erreur"
        },
        "success": {
          "message": "{{ analysisNumber }} analyses réussies",
          "title": "Succès"
        }
      }
    },
    "cells": {
      "agec": {
        "notApplicable": "Non applicable"
      },
      "traceability": {
        "traceabilityStatus": {
          "active": "Active",
          "error": "Erreur",
          "pending": "Inactive"
        }
      }
    },
    "certificates": {
      "confidential": "confidentiel",
      "directSupplier": "Fournisseur direct",
      "noAddressProvided": "Aucune adresse fournie"
    },
    "columns": {
      "agecCompliance": "Conformité",
      "agecCountry1": "Etape 1",
      "agecCountry2": "Etape 2",
      "agecCountry3": "Etape 3",
      "agecShow": "Fiche",
      "brand": "Marque",
      "collection": "Collection",
      "color": "Couleur",
      "directSupplier": "Fournisseur",
      "ingestedAt": "Ingestion",
      "name": "Nom",
      "pendingIrContact": "Information en attente de",
      "purchaseOrder": "Commande",
      "rank": "Etape {{ rank }}",
      "recycledMaterialPercentage": "Matière recyclée",
      "reference": "Référence",
      "releaseMicroplastics": "Micro-plastiques",
      "traceabilityLaunchedAt": {
        "label": "Déclenchement",
        "tooltip": "La date de déclenchement de la traçabilité du produit correspond à la date d'envoi des requêtes aux partenaires commerciaux associés"
      },
      "traceabilityStatus": {
        "label": "Traçabilité",
        "tooltip": "La traçabilité est active dès lors que la collecte d'information est en cours pour le produit."
      },
      "type": "Catégorie"
    },
    "export": {
      "all": "Exporter",
      "error": {
        "message": "Une erreur est survenue lors de l'export CSV",
        "title": "Erreur"
      },
      "view": "Exporter la vue"
    },
    "placeholders": {
      "allF": "Toutes",
      "brand": "Marque",
      "collection": "Collection",
      "companies": "Fournisseur",
      "country": "Pays",
      "expired": "Dans le passé",
      "incoming": "moins de 3 semaines",
      "ingestionDate": "Date d'ingestion",
      "launchDate": "Date de lancement",
      "searchProduct": "Recherche",
      "standard": "Standard",
      "traceabilityLaunchDate": "Déclenchement",
      "type": "Catégorie"
    },
    "tabs": {
      "certificates": "Standards",
      "customFields": "Données complémentaires",
      "general": "Catalogue",
      "traceability": "Traçabilité"
    },
    "title": "Produits"
  },
  "simulation": {
    "notSubscribed": {
      "message": "Vous n'êtes pas abonné à cette fonctionnalité. Si vous êtes intéressé, contactez votre gestionnaire de compte ou support@traceforgood.com",
      "title": "Indisponible"
    }
  },
  "sorts": {
    "brand": "Marque",
    "brandReference": "Référence",
    "brandType": "Type",
    "collection": "Collection",
    "color": "Couleur",
    "directSupplier": "Fournisseur",
    "ingestionDate": "Date d'ingestion",
    "name": "Nom",
    "purchaseOrder": "Commande",
    "traceabilityLaunchDate": "Date de lancement de la traçabilité",
    "traceabilityStatus": "Traçabilité"
  },
  "traceability": {
    "action": {
      "label": "Campagne de traçabilité",
      "tooltip": "Cliquez ici pour commencer à collecter des informations sociales et environnementales pour les produits éligibles."
    },
    "itemCard": {
      "documentName": "Preuve fournie pour ce champ, veuillez cliquer pour voir",
      "noFieldDef": "Aucun champ personnalisé"
    },
    "supplierCard": {
      "address": "Adresse",
      "company": "Fournisseur",
      "reference": "Référence"
    }
  }
}
